var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuoteinline = function SvgQuoteinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#171a1c",
    d: "M0 28q.235-7 2.353-14.467Q4.588 5.95 8 0h10.235q-2.352 6.417-3.764 13.65A81.3 81.3 0 0 0 13.177 28zm21.765 0q.235-7 2.353-14.467Q26.353 5.95 29.765 0H40q-2.353 6.417-3.765 13.65A81.3 81.3 0 0 0 34.941 28z"
  })));
};
export default SvgQuoteinline;